import authActions from '../actions/auth/auth';

const initialState = {
  user: null,
  firstAuthValidationDone: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case authActions.SET_AUTH_USER:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.user,
        },
      };
    case authActions.REMOVE_AUTH_USER:
      return {
        ...state,
        user: null,
      };
    case authActions.SET_FIRST_AUTH_STATE:
      return {
        ...state,
        user: action.user,
        firstAuthValidationDone: true,
      };
    default:
      return state;
  }
};
